import { Directive, OnDestroy, HostListener } from '@angular/core';

import { SceneService } from '../services/scene.service';

@Directive({
  selector: '[nativeCursor]',
  standalone: false,
})
export class NativeCursorDirective implements OnDestroy {
  public constructor(private sceneService: SceneService) {}

  @HostListener('pointerover') private onPointerOver() {
    this.sceneService.sceneManager?.hideCustomCursor();
  }

  @HostListener('pointerout') private onPointerOut() {
    this.sceneService.sceneManager?.showCustomCursor();
  }

  public ngOnDestroy() {
    this.sceneService.sceneManager?.showCustomCursor();
  }
}
